import React, { Component, useEffect,useState } from 'react';
import Table from '../../layout/forms/Table'
import App from './App';

const Report = ({ data, setSelectedGlobalObjectKey, state, selectedGlobalObjectKey,selectedGlobalObjectName}) => {     
    const [columns, setColumns] = useState([]);
    useEffect(() => {
        const tempColumns = [];
        tempColumns.push(
            { title: 'Project ', field: 'specifications.ProjectName', width: '10%', headerStyle: { fontSize: 13 }, cellStyle: { whiteSpace: 'nowrap' } },
            { title: 'Process Area', field: 'specifications.ProcessArea', width: '10%', headerStyle: { fontSize: 13 }, cellStyle: { whiteSpace: 'nowrap' } },
            { title: 'Object', field: 'specifications.ObjectType', width: '10%', headerStyle: { fontSize: 13 }, cellStyle: { whiteSpace: 'nowrap' } },
            { title: 'Object Name', field: 'specifications.ObjectName', width: '10%', headerStyle: { fontSize: 13 }, cellStyle: { whiteSpace: 'nowrap' } },
            { title: 'Description', field: 'specifications.ObjectDescription', width: '10%', headerStyle: { fontSize: 13 }, cellStyle: { whiteSpace: 'nowrap' } },
            { title: 'Internal Tag', field: 'specifications.InternalTag', width: '10%', headerStyle: { fontSize: 13 }, cellStyle: { whiteSpace: 'nowrap' } },
            { title: 'Customer Tag', field: 'specifications.CustomerTag', width: '10%', headerStyle: { fontSize: 13 }, cellStyle: { whiteSpace: 'nowrap' } },                        
            { title: 'Object Uid', field: 'specifications.ObjectUid', width: '10%', headerStyle: { fontSize: 13 }, cellStyle: { whiteSpace: 'nowrap' } },         
            { title: 'Global Object Key', field: 'specifications.GlobalObjectKEY', width: '10%', headerStyle: { fontSize: 13 }, cellStyle: { whiteSpace: 'nowrap' } },
            { title: 'Parent Object Key', field: 'specifications.ParentObjectKEY', width: '10%', headerStyle: { fontSize: 13, }, cellStyle: { whiteSpace: 'nowrap' } },
            
        );  
        state.specifications.forEach(
            function (d) {
                tempColumns.push({
                    title: d.label, field: 'specifications.' + d.label, width: 200, headerStyle: { fontSize: 14 }, cellStyle: { whiteSpace: 'nowrap' }
                });
            }
        ) 
        setColumns(tempColumns);
    }, [state.specifications])


  
    const onRowClick = (event, rowData) => { setSelectedGlobalObjectKey(rowData.specifications.GlobalObjectKEY) };
    return (
        <div>       
            <Table            
                tableId={'Report'}
                className={'specifications'}
                rowsPerPage={50}
                columns={columns}
                data={data}                            
                onRowClick={onRowClick}
                rowColoring={true}
                selectedGlobalObjectKey={selectedGlobalObjectKey} 
                selectedGlobalObjectName={selectedGlobalObjectName}       
                options={{
                    rowStyle: {
                        height: "12px",
                    },
                    showTitle: true
                }}
            />
        </div>
    );
};
export default Report;
//onRowClick = {(event, rowData) => { setSelectedGlobalObjectKey(rowData.specifications.GlobalObjectKEY) setSelectedObjectName(rowData.specifications.setSelectedObjectName) }}